import { useTranslation } from "react-i18next";
import { Sparkles, Layers, Plus } from "lucide-react";
import { DeptCard } from "./DeptCard";
import { DEPT_SUGGESTIONS, DeptIcon } from "./deptIcons";
import { localName } from "../../lib/localName";

// قائمة الأقسام — شبكة بطاقات + حالة فارغة مع اقتراحات جاهزة للنقر.
export const DepartmentList = ({ departments, branches, showBranch, canEdit,
                                  canDelete, onEdit, onDeleted, onQuickAdd }) => {
  const { t } = useTranslation();
  const branchMap = (branches || []).reduce((m, b) => { m[b.id] = b; return m; }, {});
  if (departments.length === 0) {
    return (
      <div className="rounded-3xl border-2 border-dashed border-border/60 bg-muted/20 p-8 text-center"
           data-testid="dept-empty">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Layers className="h-6 w-6" />
        </div>
        <p className="mt-4 text-lg font-bold">{t("departments.emptyTitle")}</p>
        <p className="mt-1 text-sm text-muted-foreground">{t("departments.emptyDesc")}</p>
        {onQuickAdd ? (
          <div className="mt-6">
            <p className="mb-3 flex items-center justify-center gap-2 text-xs font-bold text-muted-foreground">
              <Sparkles className="h-3.5 w-3.5" /> {t("departments.suggestions")}
            </p>
            <div className="flex flex-wrap justify-center gap-2">
              {DEPT_SUGGESTIONS.map((s) => (
                <button key={s.code} onClick={() => onQuickAdd(s)}
                        data-testid={`dept-suggest-${s.code}`}
                        className="flex items-center gap-2 rounded-2xl border border-border/60 bg-background px-3 py-2 text-xs font-semibold shadow-neu-sm transition hover:-translate-y-0.5 hover:brightness-110"
                        style={{ borderColor: `${s.color}55` }}>
                  <span className="flex h-6 w-6 items-center justify-center rounded-lg"
                        style={{ background: `${s.color}22`, color: s.color }}>
                    <DeptIcon iconKey={s.icon_key} className="h-3 w-3" />
                  </span>
                  {localName(s)}
                </button>
              ))}
            </div>
            <button onClick={() => onQuickAdd(null)} data-testid="dept-add-custom"
                    className="mt-4 inline-flex items-center gap-2 rounded-2xl bg-primary px-4 py-2.5 text-xs font-bold text-primary-foreground shadow-neu-sm transition hover:-translate-y-0.5">
              <Plus className="h-4 w-4" /> {t("departments.addCustom")}
            </button>
          </div>
        ) : null}
      </div>
    );
  }
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
         data-testid="dept-list">
      {departments.map((d) => (
        <DeptCard key={d.id} dept={d} branch={branchMap[d.branch_id]} showBranch={showBranch}
                  canEdit={canEdit} canDelete={canDelete}
                  onEdit={() => onEdit(d)} onDeleted={onDeleted} />
      ))}
    </div>
  );
};
